type StripPrivateKeys<T> = {
  [K in keyof T as K extends `__${string}` ? never : K]: T[K] extends object
    ? T[K] extends Array<infer U>
      ? StripPrivateKeys<U>[]
      : StripPrivateKeys<T[K]>
    : T[K];
};

export function removeGraphQLMEtaFields<T extends object>(value: T): StripPrivateKeys<T> {
  if (Array.isArray(value)) {
    return value.map(removeGraphQLMEtaFields) as StripPrivateKeys<T>;
  }

  if (value !== null && typeof value === "object") {
    const result: any = {};
    for (const [key, val] of Object.entries(value)) {
      if (!key.startsWith("__")) {
        result[key] = removeGraphQLMEtaFields(val);
      }
    }
    return result;
  }

  return value as StripPrivateKeys<T>;
}
